module.exports = __webpack_public_path__ + "static/media/juneNewsletter.17555641.pdf";